// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/components/motion.ts (COPY)
/**
 * The assessment's reveal: one eased progress, 0 → 1, that the score counts
 * up on, the bars fill on and the radar grows on. Finishes at once under
 * `prefers-reduced-motion`.
 */
import { useEffect, useState } from 'react'

const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3)

export function useProgress(durationMs: number, delayMs = 0, enabled = true): number {
  const [progress, setProgress] = useState(() => (enabled ? 0 : 1))
  useEffect(() => {
    if (!enabled) return setProgress(1)
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
    if (reduce) return setProgress(1)
    let frame = 0
    let start: number | null = null
    const tick = (now: number) => {
      if (start === null) start = now
      const t = Math.min(1, Math.max(0, (now - start - delayMs) / durationMs))
      setProgress(easeOutCubic(t))
      if (t < 1) frame = window.requestAnimationFrame(tick)
    }
    frame = window.requestAnimationFrame(tick)
    return () => window.cancelAnimationFrame(frame)
  }, [durationMs, delayMs, enabled])
  return progress
}
